<app-dashboard>
    <span>organization</span>
</app-dashboard>
